import Hero from "../Component/Hero";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";
import Riplay from "../Component/Riplay";

function InventoryFinancing() {
    return (
        <>
            <div>
                <Hero
                    imageClass='inventory-financing'
                    title='<em>Inventory Financing</em>'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='Adalah fasilitas pinjaman untuk pelaku usaha yang membutuhkan dana dalam rangka menjaga <em>cash flow</em> dengan jaminan barang persediaan (stock), dengan jangka waktu pencairan sampai dengan 180 hari.'
                    buttonText='AJUKAN PINJAMAN'
                    buttonCompanyWeb={true}
                />
                <Table type='produktif' title='inventory'/>
                {/* <PersyaratanPinjaman type='produktif'/>
                <CardDokumenPendukung type='produktif' product='inventory'/> */}
                <PengajuanPinjaman type='produktif'/>
                <Riplay type='produktif' product='inventory'/>
            </div>
        </>
    );
}

export default InventoryFinancing;
